import { useState } from "react";

import { useTranslation } from "react-i18next";

import statisticsIcon from "../../../../assets/statistics.png";
import { MatchStatus, parsedDate, printBetwayTeamNames } from "../../../../Utils";
import Modal from "../../../../common/Modal";
import StatisticsModal from "../StatisticsModal";
import styles from "./InfoHeader.module.css";

const InfoHeader = ({ match, fansUnitedSDK }) => {
	const { t } = useTranslation();

	const [isModalOpen, setIsModalOpen] = useState(false);

	const isLive = match.status.type === MatchStatus.IN_PROGRESS;

	const StatisticsButton = () => (
		<div
			className={styles.statisticsContainer}
			onClick={() => {
				setIsModalOpen(!isModalOpen);
			}}
		>
			<img src={statisticsIcon} className={styles.statisticsIcon} alt={`statistics-icon`} />
			<span className={styles.statisticsText}>{t("play.stats")}</span>
		</div>
	);

	return (
		<div className={styles.container}>
			<div>
				<div>{isLive ? <div className={styles.live}>LIVE</div> : <div className={styles.date}>{parsedDate(match?.kickoffAt)}</div>}</div>
				<div>
					{printBetwayTeamNames(match.homeTeam)} - {match.awayTeam.name}
				</div>
			</div>
			{!match.undecided && <StatisticsButton />}
			<Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={t("play.statistics")} subtitle={t("play.lastMatches")}>
				<StatisticsModal homeTeam={match.homeTeam} awayTeam={match.awayTeam} fansUnitedSDK={fansUnitedSDK} />
			</Modal>
		</div>
	);
};

export default InfoHeader;
